<template>
	<div v-if="headingImage" ref="header" :class="{ subpage: !route.name.startsWith('index') }">
		<div class="hero-image">
			<slot name="heroContent" />
			<picture>
				<source
					v-if="headingImage.imagePortraitWebp"
					:srcset="headingImage.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source
					v-if="headingImage.imagePortrait"
					:srcset="headingImage.imagePortrait"
					media="(max-width: 500px)"
				/>
				<source :srcset="headingImage.imageWebp" type="image/webp" />
				<source :srcset="headingImage.image" />
				<img class="slider-image" :src="headingImage.image" :alt="headingImage.imageAlt" />
			</picture>
			<a v-if="route.name.startsWith('index')" class="scroll-down smooth-scroll" @click="scrollDown()" />
		</div>
	</div>
</template>

<script setup>
const route = useRoute();

const header = ref(null);

const scrollDown = () => {
	const start = window.scrollY;
	const end = header.value.clientHeight;
	const distance = end - start;
	const duration = 700;
	let startTime = null;

	const easeInOutQuad = (t) => {
		// eslint-disable-next-line no-mixed-operators
		return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};

	const animateScroll = (timestamp) => {
		if (!startTime) {
			startTime = timestamp;
		}
		const timeElapsed = timestamp - startTime;
		const progress = Math.min(timeElapsed / duration, 1);
		const easedProgress = easeInOutQuad(progress);

		// eslint-disable-next-line no-mixed-operators
		window.scrollTo(0, start + distance * easedProgress);

		if (progress < 1) {
			requestAnimationFrame(animateScroll);
		}
	};

	requestAnimationFrame(animateScroll);
};

defineProps({
	headingImage: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.hero-image {
	width: 100%;
	height: 100vh;
	position: relative;
}

.hero-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.subpage .hero-image {
	height: 70vh;
}

.hero-image::before {
	content: '';
	z-index: 2;
	position: absolute;
	display: block;
	inset: 0;
	background: rgb(0 0 0 / 20%);
}

.scroll-down {
	position: absolute;
	cursor: pointer;
	bottom: 40px;
	left: 0;
	right: 0;
	margin: 0 auto;
	background: url('~/assets/images/scroll-down.svg') no-repeat center center;
	width: 59px;
	height: 80px;
	background-size: 46px;
	z-index: 2;
	animation: bounce 5s ease-in-out infinite;
}

@media screen and (max-width: 768px) and (orientation: landscape) {
	.scroll-down {
		display: none;
	}
}

@media (max-width: 480px) {
	.hero-image {
		height: 100svh;
	}

	.scroll-down {
		background-size: 32px;
	}
}

@keyframes bounce {
	0%,
	20%,
	100% {
		transform: translateY(0);
	}

	5% {
		transform: translateY(-15px);
	}

	10% {
		transform: translateY(0);
	}

	15% {
		transform: translateY(-8px);
	}

	19% {
		transform: translateY(0);
	}
}
</style>
